export enum UploadStates {
    UPLOADING = 'uploading',
    UPLOAD_FAILED = 'upload_failed',
    UPLOAD_COMPLETE = 'upload_complete',
    NONE = '',
}
